<template>
    <TVJoyDialog pattern-confirm>
        <template #dialog-header>
            <VJoyWrapper direction="row" no-margin>
                <VJoyIcon name="warning" size="medium" />
                <p>{{ $t('projectclient.quote.view.quote-summary.dialog.purchase-order.title') }}</p>
            </VJoyWrapper>
        </template>
        <template #dialog-body>
            <p class="modal__description">
                {{ $t('projectclient.quote.view.quote-summary.dialog.purchase-order.subtitle') }}
            </p>
        </template>
        <template #dialog-confirm>
            <VJoyButton variant="ghost" data-testid="purchase-order-add-later-button" @click="handleAddLater">
                {{ $t('projectclient.quote.view.quote-summary.dialog.purchase-order.add-later') }}
            </VJoyButton>
            <VJoyButton variant="main" data-testid="purchase-order-add-now-button" @click="handleAddNow">
                {{ $t('projectclient.quote.view.quote-summary.dialog.purchase-order.add-now') }}
            </VJoyButton>
        </template>
    </TVJoyDialog>
</template>

<script setup lang="ts">
    import {eventBus} from '@common/events';
    import {VJoyButton, VJoyIcon, VJoyWrapper} from '@maltjoy/core-vue';
    import {useDialogRoot} from '~/common/composables';

    defineProps<{
        quoteId: string;
        purchaseOrderInputRef?: HTMLElement;
    }>();

    const {TVJoyDialog, confirmDialog} = useDialogRoot();

    function handleAddLater() {
        confirmDialog();
        eventBus.emit('handleAddPurchaseOrderLater');
    }

    function handleAddNow() {
        confirmDialog();
        eventBus.emit('handleAddPurchaseOrderNow');
    }
</script>
